// ============================================================
// CONFIGURAÇÃO CENTRAL — FW TEAM FITNESS
// Altere APENAS este arquivo para atualizar links, logo e WhatsApp.
// ============================================================

export const SITE = {
  brand: "FW Team Fitness",
  trainerName: "Fernando Martins Júnior",
  trainerRole: "Personal Trainer",
  cref: "CREF 21418-G/DF",
  slogan: "Movimento Gera Mudança.",

  // Logo oficial fornecida pelo cliente.
  logoSrc: "/logo.webp",

  links: {
    instagram: "https://www.instagram.com/fernandofwpersonal?stkn=MWFnZDBxbmcwbXB3cg==",
    playlist: "https://open.spotify.com/user/fernandojr.farma?si=to34O4aFQiCC9RKisrvPLg",
    anamnese: "https://forms.gle/91H3hNnEVtrbzgpp9",
    appTreino: "https://fw-team-fitness.fernandomjr21.chatgpt.site/#cadastro",

    // TikTok: fora do site por enquanto (para reativar, adicione novamente ao NAV_ITEMS).

    // WhatsApp: SOMENTE números, com DDI e DDD.
    whatsappNumber: "5561920023464",
  },

  // Mensagem inicial enviada pelo link do WhatsApp.
  whatsappMessage:
    "Olá, Fernando! Vim pelo site da FW Team Fitness e gostaria de saber mais sobre o acompanhamento.",
};

// Monta o link wa.me com número apenas de dígitos + mensagem codificada.
export function whatsappUrl() {
  const digits = SITE.links.whatsappNumber?.replace(/\D/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
}

// Itens de navegação e cartões de acesso rápido (mesmos destinos do menu).
export const NAV_ITEMS = [
  {
    id: "instagram",
    label: "Instagram",
    icon: "Instagram",
    href: SITE.links.instagram,
    external: true,
    description: "Dicas de treino, novidades e o dia a dia da FW Team.",
  },
  {
    id: "playlist",
    label: "Playlist de Treino",
    icon: "Headphones",
    href: SITE.links.playlist,
    external: true,
    description: "Dê play na motivação para o seu próximo treino.",
  },
  {
    id: "anamnese",
    label: "Ficha de Anamnese",
    icon: "ClipboardList",
    href: SITE.links.anamnese,
    external: true,
    description: "Preencha sua avaliação inicial para começarmos.",
  },
  {
    id: "app",
    label: "App de Treino",
    icon: "Smartphone",
    href: SITE.links.appTreino,
    external: true,
    description: "Acesse seu programa e acompanhe seus treinos.",
  },
  {
    id: "loja",
    label: "Loja FW",
    cardLabel: "E-books",
    icon: "ShoppingBag",
    href: "#loja",
    opensMaterials: true,
    external: false,
    description: "E-books e materiais oficiais da FW Team para apoiar seus treinos.",
  },
  {
    id: "contato",
    label: "Contato",
    icon: "MessageSquare",
    href: "#contato",
    external: false,
    description: "Tire suas dúvidas e conheça o acompanhamento.",
  },
];

// Materiais de apoio exibidos na seção #materiais. Para adicionar novos materiais,
// basta incluir um item aqui (label, ícone, href e descrição).
export const MATERIAIS = [
  {
    id: "ebook-peso",
    label: "E-Book: Peso que sai, corpo que fica",
    icon: "BookOpen",
    href: "https://hotmart.com/pt-br/marketplace/produtos/peso-que-sai-corpo-que-fica/R108082317H?system=product_page",
    checkout: "https://pay.hotmart.com/R108082317H?checkoutMode=2",
    description:
      "O e-book oficial da FW Team Fitness, disponível na Hotmart.",
  },
  {
    id: "ebook-correr",
    label: "E-Book: Correr com Método: do primeiro quilômetro à prova alvo",
    icon: "BookOpen",
    href: "https://fernandojr-farma.hotmart.host/correr-com-metodo-do-primeiro-quilometro-a-prova-alvo-5cc114f6-b20c-45d3-85a0-1463cded1a4e",
    checkout: "https://pay.hotmart.com/H108089106R?checkoutMode=2",
    description:
      "Guia de corrida do primeiro quilômetro à prova alvo, disponível na Hotmart.",
  },
];
